export default (text) =>
  `${text.charAt(0).toUpperCase()}${text.substring(1).toLowerCase()}`;
